(() => {
  if (window.wboCartReadiness) return;

  let blocked = false;
  const onCartPage = document.body.classList.contains('wbo-template-cart');
  const expressSelector = '.additional-checkout-buttons, .cart__dynamic-checkout-buttons, shopify-accelerated-checkout-cart';
  const checkoutPath = (value) => {
    if (!value) return false;
    try {
      return /(?:^|\/)checkouts?(?:\/|$)/.test(new URL(value, window.location.href).pathname);
    } catch {
      return false;
    }
  };

  const refresh = () => {
    if (document.querySelector('[data-wbo-cart-readiness="incomplete"]')) blocked = true;
    if (!blocked) return;

    if (!document.documentElement.hasAttribute('data-wbo-cart-blocked')) {
      document.documentElement.setAttribute('data-wbo-cart-blocked', '');
    }
    document.querySelectorAll('#checkout, [name="checkout"]').forEach((control) => {
      if ('disabled' in control && !control.disabled) control.disabled = true;
      if (control.getAttribute('aria-disabled') !== 'true') control.setAttribute('aria-disabled', 'true');
      if (control.getAttribute('aria-describedby') !== 'WboCartReadinessMessage') {
        control.setAttribute('aria-describedby', 'WboCartReadinessMessage');
      }
    });
    document.querySelectorAll(expressSelector).forEach((control) => {
      if (!control.hidden) control.hidden = true;
      if (!control.inert) control.inert = true;
    });
    const message = document.getElementById('WboCartReadinessMessage');
    if (message?.hidden) message.hidden = false;
  };

  const stop = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    document.getElementById('WboCartReadinessMessage')?.focus();
  };

  const reviewCart = (event) => {
    event.preventDefault();
    event.stopImmediatePropagation();
    const url = new URL(window.routes?.cart_url || '/cart', window.location.origin);
    if (document.body.dataset.wboPreviewTheme) {
      url.searchParams.set('preview_theme_id', document.body.dataset.wboPreviewTheme);
    }
    window.location.assign(url.href);
  };

  window.addEventListener('click', (event) => {
    const target = event.target instanceof Element ? event.target : event.target?.parentElement;
    if (target?.closest('.shopify-payment-button, shopify-accelerated-checkout')) return;
    if (target?.closest('[data-wbo-cart-reload]')) {
      event.preventDefault();
      window.location.reload();
      return;
    }
    refresh();
    if (!target) return;
    const link = target.closest('a[href]');
    const checkout = target.closest(`#checkout, [name="checkout"], ${expressSelector}`) || checkoutPath(link?.getAttribute('href'));
    if (!checkout) return;
    if (!onCartPage) reviewCart(event);
    else if (blocked) stop(event);
  }, true);

  window.addEventListener('submit', (event) => {
    refresh();
    if (!(event.target instanceof HTMLFormElement)) return;
    const form = event.target;
    if (event.submitter?.closest('.shopify-payment-button, shopify-accelerated-checkout')) return;
    const checkout = form.id === 'cart' || form.id === 'CartDrawer-Form' || form.id === 'cart-notification-form' ||
        event.submitter?.name === 'checkout' || form.querySelector('[name="checkout"]') ||
        checkoutPath(form.action) || checkoutPath(event.submitter?.formAction);
    if (!checkout) return;
    if (!onCartPage) reviewCart(event);
    else if (blocked) stop(event);
  }, true);

  window.wboCartReadiness = { refresh };
  refresh();
  new MutationObserver(refresh).observe(document.body, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['disabled', 'hidden', 'inert', 'data-wbo-cart-readiness'],
  });
})();
